import { GrowpIcon } from 'packages/components/GrowpIcon'
import { PermEnum } from 'packages/sdks-next/growp'
import { MenuItemUnion } from 'packages/web-layout/types'

export const useTeacherManagementMenu: () => MenuItemUnion[] = () => {
  return [
    {
      path: '/admin/teacherManagement',
      label: (
        <GrowpIcon
          name="Teacher"
          text="教师管理"
          size={14}
          textMarginLeft={16}
        />
      ),
      labelText: '教师管理',
      height: 40,
      perm: PermEnum.FormalTeacher,
    },
  ]
}
